export const PESSOAS_LISTAR_BEGIN = 'PESSOAS_LISTAR_BEGIN';
export const PESSOAS_LISTAR_SUCCESS = 'PESSOAS_LISTAR_SUCCESS';
export const PESSOAS_LISTAR_FAILURE = 'PESSOAS_LISTAR_FAILURE';
export const PESSOAS_LISTAR_DISMISS_ERROR = 'PESSOAS_LISTAR_DISMISS_ERROR';
export const PESSOAS_BUSCAR_POR_ID_BEGIN = 'PESSOAS_BUSCAR_POR_ID_BEGIN';
export const PESSOAS_BUSCAR_POR_ID_SUCCESS = 'PESSOAS_BUSCAR_POR_ID_SUCCESS';
export const PESSOAS_BUSCAR_POR_ID_FAILURE = 'PESSOAS_BUSCAR_POR_ID_FAILURE';
export const PESSOAS_BUSCAR_POR_ID_DISMISS_ERROR = 'PESSOAS_BUSCAR_POR_ID_DISMISS_ERROR';
export const PESSOAS_EDITAR_BEGIN = 'PESSOAS_EDITAR_BEGIN';
export const PESSOAS_EDITAR_SUCCESS = 'PESSOAS_EDITAR_SUCCESS';
export const PESSOAS_EDITAR_FAILURE = 'PESSOAS_EDITAR_FAILURE';
export const PESSOAS_EDITAR_DISMISS_ERROR = 'PESSOAS_EDITAR_DISMISS_ERROR';



// WEBPACK FOOTER //
// ./src/features/pessoas/redux/constants.js